import React, { Component } from "react";
import { Table, Button } from "antd";
import { PlusOutlined, PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

import { TableSearchBar } from "./search-bar/table-search-bar";
import { AddCar } from "../vehicle/add-car";
import { apiVehicle } from "../../../api/api-vehicle";
import { emitter } from "../../../common/utils/emitter";
import { CAR_STATUS } from "../../../common/utils/static-data";
import { alert } from "../../../common/utils/alert";

export class VehicleTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
      isAddCar: false,
      typeOption: "create_new",
      exportFilter: {
        model: null,
        number_plate: null,
        travel_warrant_expiry_date: null,
        registration_to_date: null,
        road_fee_expiry_date: null,
        vehicle_supplier_group: {
          id: null,
        },
      },
    };

    this.page = 1;

    this.customerTable = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        maxWidth: 60,
      },
      {
        title: "Model",
        dataIndex: "model",
        key: "model",
      },
      {
        title: "Biển KS",
        dataIndex: "number_plate",
        key: "number_plate",
      },
      {
        title: "Nguồn xe",
        dataIndex: "vehicle_supplier_group_id",
        key: "vehicle_supplier_group_id",
        render: (item) => <div style={{ minWidth: 60 }}>{item.name}</div>,
      },
      {
        title: "Ngày hết hạn giấy đi đường",
        dataIndex: "travel_warrant_expiry_date",
        key: "travel_warrant_expiry_date",
        render: (item) => (
          <div style={{ minWidth: 60 }}>
            {item ? moment(item).format("DD/MM/YYYY") : ""}
          </div>
        ),
      },
      {
        title: "Ngày đăng kiểm tới",
        dataIndex: "registration_to_date",
        key: "registration_to_date",
        render: (item) => (
          <div style={{ minWidth: 60 }}>
            {item ? moment(item).format("DD/MM/YYYY") : ""}
          </div>
        ),
      },
      {
        title: "Ngày hết hạn phí đường bộ",
        dataIndex: "road_fee_expiry_date",
        key: "road_fee_expiry_date",
        render: (item) => (
          <div style={{ minWidth: 60 }}>
            {item ? moment(item).format("DD/MM/YYYY") : ""}
          </div>
        ),
      },
      {
        title: "Chi tiết",
        dataIndex: "data",
        key: "detail",
        render: (data) => (
          <div style={{ minWidth: 60 }} onClick={() => this.showDetail(data)}>
            <img
              alt=""
              className="detail-icon"
              src={require("../../../assets/icons/info-circle-solid.png")}
            />
          </div>
        ),
      },
    ];
  }

  getData = async (page) => {
    const { state } = this.search;
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }
    if (state.checkSearch) {
      this.setState({
        exportFilter: {
          branch_id: state?.branch_id || null,
          model: state.model
            ? `%${state.model
                .trim()
                .replace(/%/gi, "\\%")
                .replace(/_/g, "\\_")}%`
            : null,
          number_plate: state.number_plate
            ? `%${state.number_plate.trim().replace(/%/gi, "\\%")}%`
            : null,
          vehicle_supplier_group: {
            id: state.resource && state.resource >= 0 ? state.resource : null,
          },
          travel_warrant_expiry_date: state.travel_warrant_expiry_date,
          registration_to_date: state.registration_to_date,
          road_fee_expiry_date: state.road_fee_expiry_date,
        },
      });
    }
    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiVehicle.getCars(this.state.exportFilter, page);
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.total_elements },
          () => {}
        );
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  componentDidMount() {
    this.getData(1);
  }

  showDetail = (data) => {
    this.handleAddCar(true, "show_detail", data);
  };

  handleAddCar = (status, type, data) => {
    this.setState({ isAddCar: status, typeOption: type }, () => {
      const element = document.getElementById("right-layout");
      element.scrollTo(0, 0);
      if (data) {
        this.addCar.updateFormCar(data);
      }
      if (!status) {
        this.getData(1);
      }
    });
  };

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    this.getData(page);
  };

  handleExportVehicle = async () => {
    try {
      const { state } = this.search;
      const { total, exportFilter } = this.state;
      const totalItem = total < 10 ? 10 : total;
      emitter.emit("FETCH_LOADING", true);
      apiVehicle.exportVehicle(exportFilter, 1, totalItem).then((res) => {
        if (res === "success") {
          alert("success", "Export thành công");
          emitter.emit("FETCH_LOADING", false);
        } else {
          alert("error", "Không export thành công");
          emitter.emit("FETCH_LOADING", false);
        }
      });
    } catch (error) {
      alert("error", "Không export thành công");
      emitter.emit("FETCH_LOADING", false);
    }
  };

  render() {
    const { dataTable, total, isAddCar, typeOption } = this.state;

    return (
      <div className="contract-table">
        {!isAddCar ? (
          <>
            <div
              style={{
                color: "#d20a30",
                paddingTop: "20px",
                fontSize: "1em",
                display: "flex",
                alignItems: "center",
              }}
            >
              Danh sách xe
            </div>
            <TableSearchBar
              search={this.getData}
              ref={(ref) => (this.search = ref)}
              type="VEHICLE"
            />
            <Table
              rowKey={(record) => record.id}
              style={{ width: "100%" }}
              dataSource={dataTable}
              pagination={{
                total,
                pageSize: 10,
                onChange: this.onChangePage,
                current: this.page,
              }}
              //pagination={false}
              scroll={{ x: true }}
              columns={this.customerTable}
            />
            <div className="button-container">
              <Button
                onClick={() => this.handleAddCar(true, "create_new")}
                className="add-btn"
              >
                <PlusOutlined /> Thêm xe
              </Button>
              <Button className="export-btn" onClick={this.handleExportVehicle}>
                <PrinterOutlined /> Export
              </Button>
            </div>
          </>
        ) : (
          <AddCar
            typeOption={typeOption}
            ref={(ref) => (this.addCar = ref)}
            close={() => this.handleAddCar(false)}
          />
        )}
      </div>
    );
  }
}
